// extracted by mini-css-extract-plugin
export default {"container":"lGPR_OXm","icon":"MEVIHN98"};